import { render } from "./LoadingIconLarge.vue?vue&type=template&id=7575b474"
import script from "./LoadingIconLarge.vue?vue&type=script&lang=ts"
export * from "./LoadingIconLarge.vue?vue&type=script&lang=ts"
script.render = render

export default script